import React from "react";
import { Box, Chip, Typography, Button, Stack } from "@mui/material";
import CreditScoreIcon from "@mui/icons-material/CreditScore";

const bgMap = {
  warning: "#f57c00",  // deep orange
  info: "#1976d2",     // strong blue
  success: "#388e3c",  // rich green
};



export default function OfferBox({ offer }) {
  return (
    <Box

  sx={{
    width: "100%",
    borderRadius: 2,
    p: 2,
    bgcolor: bgMap[offer.badgeColor] || "background.paper",
    boxShadow: 1,
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
  }}
    >

      {/* Title + Type */}
      <Typography variant="subtitle1" fontWeight={600}>
        {offer.title}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {offer.type}
      </Typography>

      {/* Status Badge */}
      <Chip
        label={offer.badge}
        size="small"
        sx={{
          alignSelf: "start",
          bgcolor: `${offer.badgeColor}.main`,
          color: "white",
          fontWeight: 500,
        }}
      />

      {/* Est. Value */}
      <Typography
        variant="h6"
        fontWeight={700}
        sx={{ color: offer.valueColor }}
      >
        {offer.value}
      </Typography>

      {/* Description */}
      <Typography variant="body2" color="text.secondary">
        {offer.description}
      </Typography>

      {/* Requirements Chips */}
      <Stack direction="row" spacing={1} flexWrap="wrap">
        {offer.requirements?.map((req, idx) => (
          <Chip
            key={idx}
            label={req}
            size="small"
            variant="outlined"
            sx={{ fontSize: "0.75rem" }}
          />
        ))}
      </Stack>

      {/* Credit Score */}
      <Stack direction="row" alignItems="center" spacing={1}>
        <CreditScoreIcon fontSize="small" color="action" />
        <Typography variant="caption" color="text.secondary">
          {offer.creditScore}
        </Typography>
      </Stack>

      {/* Buttons */}
      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
        <Button variant="outlined" size="small">
          Details
        </Button>
        <Button variant="contained" size="small">
          Apply
        </Button>
      </Stack>
    </Box>
  );
}
